import Actions from 'actions';

const initialState = Object.freeze({});

function attend(state = initialState, action) {
  switch (action.type) {
    case Actions.ATTENDING_EVENT_REQUEST:
      return initialState;
    case Actions.ATTENDING_EVENT_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.ATTENDING_EVENT_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default attend;
